export default {
    locale: JSON.parse(localStorage.getItem('LOCALE') ?? '{}')?.locale || 'zh-CN' //默认语钟，这个是language的store做了缓存
}
